import type { IDBPDatabase } from 'idb'
import type { MigrationStateStore } from '../migrations/runner.js'
import { SCHEMA_VERSION_META_KEY, type VaultDbSchema } from './idb-record-store.js'

/** Schema-version checkpoint stored in the vault's `meta` object store. */
export class IdbMigrationStateStore implements MigrationStateStore {
  constructor(private readonly db: IDBPDatabase<VaultDbSchema>) {}

  async readVersion(): Promise<number> {
    const value = await this.db.get('meta', SCHEMA_VERSION_META_KEY)
    return typeof value === 'number' ? value : 0
  }

  async writeVersion(version: number): Promise<void> {
    await this.db.put('meta', version, SCHEMA_VERSION_META_KEY)
  }
}
